import { IPermitTypeField } from '~/client/graph/types.generated'
import { conditionalPermitFields } from '~/client/src/shared/constants/PermitFieldTypeConstants'
import { MAX_CONDITIONAL_DEPTH_LEVEL } from '~/client/src/shared/constants/permitTypeFieldsConstants'

export const isInnerConfiguratorShown = (
  field: IPermitTypeField,
  depthLevel: number,
): boolean => {
  return (
    !field.isMultiple &&
    conditionalPermitFields.includes(field.type) &&
    depthLevel < MAX_CONDITIONAL_DEPTH_LEVEL
  )
}
